"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = require("../../api/axiosClient");
const NewFeatureSupportLevelsAPI = {
    makeBaseURI() {
        return `/v2/support-levels`;
    },
    featuresSupportLevel(openshiftVersion, cpuArchitecture, platformType) {
        return axiosClient_1.clientWithoutCaseConverter.get(`${NewFeatureSupportLevelsAPI.makeBaseURI()}/features`, {
            params: Object.assign({ openshift_version: openshiftVersion, cpu_architecture: cpuArchitecture, platform_type: platformType }, (platformType === 'external' ? { external_platform_name: 'oci' } : {})),
        });
    },
    architecturesSupportLevel(openshiftVersion) {
        let queryParams = '?';
        queryParams += openshiftVersion ? `openshift_version=${openshiftVersion}&` : '';
        return axiosClient_1.clientWithoutCaseConverter.get(`${NewFeatureSupportLevelsAPI.makeBaseURI()}/architectures${queryParams}`);
    },
};
exports.default = NewFeatureSupportLevelsAPI;
//# sourceMappingURL=NewFeatureSupportLevelsAPI.js.map